/**
 * Styled Components - Created by david on 17/04/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  margin: 0px 32px;
  padding: 12px 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
  user-select: none;
  cursor: pointer;

  &:hover {
    background-color: #fafafa;
  }
`

export const ContainerRow = styled.div`
  padding: 12px 2px;
  display: flex;
  flex-direction: row;
  margin-right: 16px;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
  flex-flow: column;
  align-items: flex-start;
  &:hover {
    background-color: #fafafa;
  }
`

export const Title = styled.div`
  user-select: none;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  font-family: Avenir;
`

export const TitleRow = styled.div`
  user-select: none;
  color: #5f6062;
  font-family: Avenir Next !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 6px;
  font-family: Avenir;
`

export const Option = styled.div`
  user-select: none;
  color: #5f6062;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
`

interface CircleProps {
  color: string
}

export const Circle = styled.div`
  user-select: none;
  height: 30px;
  width: 30px;
  border: 1px solid #bebebe;
  margin-left: 8px;
  background-color: ${({ color }: CircleProps) => color};
  border-radius: 50%;
`

export const Row = styled.div`
  user-select: none;
  padding-left: 12px;
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const RowItem = styled.div`
  user-select: none;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 38px;
  .ant-radio-group {
    font-size: 12px;
  }
  .ant-radio-button-wrapper {
    height: 38px;
    padding: 2px 10px;
  }
  .ant-input-number {
    height: 38px;
    max-width: 74px;
    padding-top: 2px;
  }
  .ant-input-number-input-wrap {
    padding-top: 2px;
  }
`

export const Icon = styled.img`
  user-select: none;
  padding-left: 12px;
`
export const RowContent = styled.span`
  display: inline-flex;
`
export const CrossLine = styled.div`
  display: block;
  background: red;
  width: 2px;
  height: 100%;
  margin: 0 auto;
  transform: rotate(45deg);
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OptionText/styledComponents.tsx